const PREFIX = '[PROJECT_NAME]'

// 消息对象
class Target {
  target: any
  name: string
  prefix: string
  constructor(target: any, name: any, prefix: any) {
    let errMsg = ''
    if (!target || !name) {
      errMsg = 'target error - target and name are both required'
    } else if (typeof target !== 'object') {
      errMsg = 'target error - target itself must be window object'
    } else if (typeof name !== 'string') {
      errMsg = 'target error - target name must be string type'
    }
    if (errMsg) {
      throw new Error(errMsg)
    }
    this.target = target
    this.name = name
    this.prefix = prefix
  }

  send(msg: any) {
    this.target.postMessage(`${this.prefix}|${this.name}__Messenger__${msg}`, '*')
  }
}

// 信使类
class Messenger {
  targets: any
  name: any
  listenFunc: any[]
  prefix: string
  constructor(messengerName: any, projectName: any) {
    // 消息对象集合
    this.targets = {}
    // 信使名
    this.name = messengerName
    // 监听回调
    this.listenFunc = []
    // 项目名
    this.prefix = projectName || PREFIX
    // 初始化回调
    this.initListen()
  }

  // 给信使添加消息对象，可以一对多
  addTarget(target: any, name: any) {
    const targetObj = new Target(target, name, this.prefix)
    this.targets[name] = targetObj
  }

  // 初始化
  initListen() {
    const self = this
    // 原始api回调
    const generalCallback = function (msg: MessageEvent) {
      // 仅接受父窗口（编辑器宿主 iframe）发来的消息。
      // postMessage 的 source 无法伪造：外部页面通过 window.open 打开本页后，
      // 其 event.source 是 opener 而非 window.parent，可据此拦截伪造的编辑器指令
      if (!msg || msg.source !== window.parent) {
        return
      }
      let _msg = ''
      if (typeof msg === 'object' && msg.data) {
        _msg = msg.data
      }
      if (!_msg || !_msg.split) {
        return
      }

      const msgPairs = _msg.split('__Messenger__')
      _msg = msgPairs[1]
      const pairs = msgPairs[0].split('|')
      const prefix = pairs[0]
      const name = pairs[1]
      self.listenFunc.forEach((item) => {
        // 消息体判断，所有的接受消息要过滤
        if (prefix + name === self.prefix + self.name) {
          item(_msg)
        }
      })
    }

    if ('addEventListener' in document) {
      window.addEventListener('message', generalCallback, false)
    } else if ('attachEvent' in document) {
      (window as any).attachEvent('onmessage', generalCallback)
    }
  }

  // 消息监听
  listen(callback: any) {
    let cbIsExist = -1
    cbIsExist = this.listenFunc.findIndex((item) => item === callback)
    if (cbIsExist === -1) {
      this.listenFunc.push(callback)
    } else {
      console.warn('重复监听')
    }
  }

  // 注销
  clear() {
    this.listenFunc = []
  }

  // 广播  向所有target广播
  send(msg: any) {
    const targets = this.targets
    Object.keys(targets).forEach((key) => {
      targets[key].send(msg)
    })
  }
}

export default Messenger
